import { NotFound } from '@systemeio/util'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { TWILIO_PHONE_NUMBERS_PATH } from '../api'
import { TwilioPhoneNumbersListInterface } from '../types'

export function useTwilioPhoneNumbers() {
  const { user } = useUser()
  const { fetcher: fetchIntegration } = useFetch<
    RequestMethodsEnum.get,
    TwilioPhoneNumbersListInterface
  >({
    method: RequestMethodsEnum.get,
    onNotFound: error => {
      throw error
    },
  })

  const { data, mutate, isLoading, isValidating, error } = useControlledSwr(() => {
    if (!user) return
    return [TWILIO_PHONE_NUMBERS_PATH, RequestModuleEnum.TwilioPhoneNumbers]
  }, fetchIntegration)

  const errorNotFound = error instanceof NotFound ? error : undefined

  return {
    data,
    errorNotFound,
    mutate,
    isLoading,
    isValidating,
  }
}
